// Product catalogue — every product has unique, benefit-led copy. Edit here once.
const IMG = {
  hero: "https://images.pexels.com/photos/8092165/pexels-photo-8092165.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  roller:
    "https://images.unsplash.com/photo-1776261293170-66fd3b09273e?crop=entropy&cs=srgb&fm=jpg&q=85",
  roman:
    "https://images.pexels.com/photos/8092176/pexels-photo-8092176.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  venetian:
    "https://images.pexels.com/photos/3915040/pexels-photo-3915040.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  vertical:
    "https://images.unsplash.com/photo-1777340183462-a73bc9c57284?crop=entropy&cs=srgb&fm=jpg&q=85",
  daynight:
    "https://images.pexels.com/photos/37609127/pexels-photo-37609127.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  perfectfit:
    "https://images.unsplash.com/photo-1588445139602-fc4279e662d6?crop=entropy&cs=srgb&fm=jpg&q=85",
  motorised:
    "https://images.unsplash.com/photo-1759804053484-4619d8ca588f?crop=entropy&cs=srgb&fm=jpg&q=85",
  skylight:
    "https://images.pexels.com/photos/10096727/pexels-photo-10096727.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  blackout:
    "https://images.pexels.com/photos/6980665/pexels-photo-6980665.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  shutters:
    "https://images.pexels.com/photos/34680723/pexels-photo-34680723.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  shuttersSunroom:
    "https://images.pexels.com/photos/30473966/pexels-photo-30473966.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  livingRoom:
    "https://images.pexels.com/photos/8092165/pexels-photo-8092165.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bedroom:
    "https://images.unsplash.com/photo-1613685703237-6628de38ddb7?crop=entropy&cs=srgb&fm=jpg&q=85",
  kitchen:
    "https://images.pexels.com/photos/6580229/pexels-photo-6580229.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  bayWindow:
    "https://images.pexels.com/photos/8092176/pexels-photo-8092176.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};
export const IMAGES = IMG;

export const products = [
  {
    slug: "roller-blinds",
    name: "Roller Blinds",
    short:
      "Clean, contemporary and endlessly versatile — a made-to-measure roller blind in your choice of hundreds of fabrics.",
    heroTagline: "Simple, tailored and beautifully practical",
    intro: [
      "Roller blinds are the quiet achievers of window dressing: a single length of fabric, cut precisely to your window, that rolls away neatly when you want the light and drops smoothly when you do not.",
      "Because we make every roller blind to your exact measurements, there are no untidy gaps at the edges and no trimming blinds down at home. You choose the fabric, the finish and the controls — we handle the measuring and fitting.",
    ],
    benefits: [
      "Hundreds of fabrics, from soft sheers to full blackout",
      "Moisture-resistant options for kitchens and bathrooms",
      "Neat, minimal profile that suits modern interiors",
      "Chain, spring or motorised operation",
    ],
    rooms: ["Kitchens", "Bathrooms", "Living rooms", "Home offices"],
    options: [
      "Sheer, dimout and blackout fabrics",
      "Plain, textured and patterned designs",
      "Moisture-resistant and wipeable finishes",
      "Colour-matched bottom bars and brackets",
    ],
    light:
      "Choose sheer fabrics to soften daylight, dimout for gentle privacy, or a blackout fabric where you need a room properly dark.",
    faqs: [
      {
        q: "Are roller blinds suitable for bathrooms?",
        a: "Yes. We supply moisture-resistant, wipeable roller fabrics designed for humid rooms such as bathrooms and kitchens. We will show you suitable options during your home visit.",
      },
      {
        q: "Can roller blinds blackout a bedroom?",
        a: "A blackout roller fabric blocks the light passing through the fabric itself. Because any roller blind sits slightly off the window, a fine halo of light can remain at the edges — your specialist will explain how to minimise this.",
      },
      {
        q: "Can my roller blind be motorised?",
        a: "Yes. Most of our roller blinds can be motorised with a rechargeable battery motor and remote or app control. See our motorised blinds page for details.",
      },
    ],
    image: IMG.roller,
    related: ["day-night-blinds", "blackout-blinds", "motorised-blinds"],
  },
  {
    slug: "roman-blinds",
    name: "Roman Blinds",
    short:
      "Soft folds of made-to-measure fabric that bring the warmth of curtains with the tidiness of a blind.",
    heroTagline: "Tailored softness for bedrooms and living rooms",
    intro: [
      "Roman blinds fold into soft, even pleats as they rise, giving you the elegance of drapery without the volume. Made to measure in your chosen fabric, they sit beautifully inside a recess or dress a window from above the frame.",
      "They are a favourite for bedrooms, living rooms and dining rooms — anywhere you want warmth, texture and a more furnished feel. Add a blackout or thermal lining and they are as practical as they are handsome.",
    ],
    benefits: [
      "Soft, furnished look with a fraction of the bulk of curtains",
      "Blackout, thermal and interlined lining options",
      "Huge choice of fabrics, plains and patterns",
      "Made precisely to your window for an even, tailored fall",
    ],
    rooms: ["Bedrooms", "Living rooms", "Dining rooms", "Snugs"],
    options: [
      "Standard, blackout, thermal and interlined linings",
      "Chain or cord operation with child-safe fittings",
      "Recessed or face-fixed fitting",
      "Co-ordinating cushions and accessories available",
    ],
    light:
      "With a blackout lining, a roman blind gives excellent room darkening for bedrooms. Standard linings gently filter daylight while keeping privacy.",
    faqs: [
      {
        q: "Are roman blinds good for bedrooms?",
        a: "They are one of our most popular bedroom choices. Specify a blackout lining and the blind will keep the room comfortably dark while adding real softness to the space.",
      },
      {
        q: "Can roman blinds help with a cold window?",
        a: "A thermal or interlined roman blind adds a useful layer of insulation at the window, helping rooms feel cosier in winter.",
      },
      {
        q: "Do roman blinds suit bay windows?",
        a: "Yes — each section of the bay gets its own made-to-measure blind, which follows the shape of the window far more neatly than a single covering.",
      },
    ],
    image: IMG.roman,
    related: ["blackout-blinds", "roller-blinds", "venetian-blinds"],
  },
  {
    slug: "venetian-blinds",
    name: "Venetian Blinds",
    short:
      "Crisp horizontal slats in aluminium, real wood or faux wood — fingertip control over light and privacy.",
    heroTagline: "Precise light control with a tailored edge",
    intro: [
      "Venetian blinds give you something no fabric blind can: exact control. Tilt the slats a fraction and the room changes — bright but private, shaded but never gloomy.",
      "Choose slimline aluminium for a sharp contemporary look, real wood for warmth and character, or faux wood where steam and splashes rule out timber. Every blind is made to your window's measurements and fitted by our team.",
    ],
    benefits: [
      "Tilt the slats for precise light and privacy control",
      "Real wood, faux wood and aluminium ranges",
      "Faux wood ideal for kitchens and bathrooms",
      "Wide choice of slat widths and finishes, including tapes",
    ],
    rooms: ["Kitchens", "Bathrooms", "Living rooms", "Offices"],
    options: [
      "25mm, 35mm and 50mm slat options",
      "Matte, gloss, woodgrain and metallic finishes",
      "Decorative ladder tapes on wooden blinds",
      "Cord or wand controls with child-safety devices",
    ],
    light:
      "Few blinds manage light as well. Angle the slats up to bounce daylight onto the ceiling, or close them fully for privacy — all without raising the blind.",
    faqs: [
      {
        q: "Real wood or faux wood — which should I choose?",
        a: "Real wood is lighter and brings natural grain and warmth, ideal for living rooms and bedrooms. Faux wood is heavier but shrugs off moisture, making it the better choice for kitchens and bathrooms. We will bring samples of both.",
      },
      {
        q: "Are venetian blinds hard to keep clean?",
        a: "Not especially. A quick dust or a wipe with a damp cloth keeps slats looking fresh. Faux wood and aluminium are the easiest of all to maintain.",
      },
      {
        q: "Can venetians be fitted to a bay window?",
        a: "Yes. Each window in the bay is measured individually so the blinds follow the angle of the bay neatly, with minimal gaps.",
      },
    ],
    image: IMG.venetian,
    related: ["perfect-fit-blinds", "day-night-blinds", "roller-blinds"],
  },
  {
    slug: "vertical-blinds",
    name: "Vertical Blinds",
    short:
      "The practical answer for wide windows, patio doors and offices — smooth, adjustable and made to measure.",
    heroTagline: "Effortless coverage for wide windows and doors",
    intro: [
      "For floor-to-ceiling glass, patio doors and wide windows, vertical blinds remain hard to beat. Louvres draw back completely for a clear view, then tilt to shade glare while keeping the room bright.",
      "Modern vertical fabrics are a world away from the office blinds of old — soft weaves, gentle colours and textured finishes that sit comfortably in any room of the house.",
    ],
    benefits: [
      "Ideal for patio doors, bi-folds and wide windows",
      "Louvres tilt for glare control without losing the light",
      "Huge range of contemporary fabrics",
      "Hard-wearing and easy to maintain",
    ],
    rooms: ["Patio doors", "Conservatories", "Dining rooms", "Offices"],
    options: [
      "Blackout, dimout and glare-reducing fabrics",
      "Chain-free and sewn-in weight options",
      "Wand or cord operation",
      "Curved headrails for bays on request",
    ],
    light:
      "Tilt the louvres to redirect harsh sun while keeping a view out — particularly useful on south-facing glass and in conservatories.",
    faqs: [
      {
        q: "Are vertical blinds dated?",
        a: "Not with today's fabrics. Soft textures and contemporary colours have made verticals popular again, and for very wide glass they are still the most practical solution.",
      },
      {
        q: "Can I replace just the fabric later?",
        a: "In many cases yes — the louvres can be replaced on the existing headrail, which is a cost-effective way to refresh a room.",
      },
      {
        q: "Do vertical blinds work in conservatories?",
        a: "They are one of the best options: they cover large spans, tilt to manage heat and glare, and draw back fully when you want the garden view.",
      },
    ],
    image: IMG.vertical,
    related: ["perfect-fit-blinds", "day-night-blinds", "roller-blinds"],
  },
  {
    slug: "day-night-blinds",
    name: "Day & Night Blinds",
    short:
      "Alternating sheer and opaque stripes let you slide from full daylight to full privacy in one movement.",
    heroTagline: "Two blinds in one — sheer to private in seconds",
    intro: [
      "Day & night blinds layer two sheets of alternating sheer and opaque stripes. Align the stripes and daylight filters through; shift them and the opaque bands overlap for privacy.",
      "It is an elegant answer for street-facing living rooms, home offices and anywhere you want flexible light without raising the blind at all.",
    ],
    benefits: [
      "Shift from sheer to private without raising the blind",
      "Contemporary striped look in soft neutral palettes",
      "Great for street-facing windows",
      "Smooth chain operation, motorisation available",
    ],
    rooms: ["Living rooms", "Home offices", "Dining rooms", "Bedrooms"],
    options: [
      "Sheer and dimout stripe combinations",
      "Neutrals, greys and bolder accent colours",
      "Co-ordinated cassette and bottom bar finishes",
      "Motorised upgrade available",
    ],
    light:
      "Think of it as a dimmer for daylight. Partially align the stripes to take the edge off glare while keeping the room bright and the view intact.",
    faqs: [
      {
        q: "How do day & night blinds actually work?",
        a: "Two layers of fabric with alternating sheer and opaque stripes move past each other as you operate the control. Align sheers for light, overlap the opaque stripes for privacy.",
      },
      {
        q: "Can people see in at night?",
        a: "With the opaque stripes overlapped, you get privacy similar to a standard roller blind. As with any blind, we recommend closing them fully after dark in overlooked rooms.",
      },
      {
        q: "Are they suitable for bedrooms?",
        a: "They work well for privacy, but the sheer stripes will always let some light through. If you need a properly dark room, we would suggest a blackout blind instead.",
      },
    ],
    image: IMG.daynight,
    related: ["roller-blinds", "motorised-blinds", "venetian-blinds"],
  },
  {
    slug: "perfect-fit-blinds",
    name: "Perfect Fit Blinds",
    short:
      "A neat frame that clips straight onto uPVC windows and doors — no drilling, no screws, no gaps.",
    heroTagline: "No drilling. No gaps. Just a perfect fit.",
    intro: [
      "Perfect Fit blinds sit inside their own slim frame, which clips directly onto the window bead of uPVC windows and doors. There is no drilling into frames, no dangling cords and no gaps at the sides.",
      "Because the blind moves with the window or door, they are superb for tilt-and-turn windows, French doors and conservatories — and a tidy, cord-free choice for homes with children.",
    ],
    benefits: [
      "Clips onto uPVC frames — no drilling required",
      "Cord-free operation, ideal around children",
      "Moves with tilt-and-turn windows and doors",
      "Pleated, venetian and roller fabric choices",
    ],
    rooms: ["Conservatories", "Tilt-and-turn windows", "French doors", "Bedrooms"],
    options: [
      "Pleated, venetian or roller inserts",
      "Frame colours to match your windows",
      "Blackout pleated fabrics for bedrooms",
      "Top-down styles available on selected ranges",
    ],
    light:
      "The frame reduces the light gaps you get with standard blinds, and blackout pleated fabrics make Perfect Fit a strong choice for bedrooms.",
    faqs: [
      {
        q: "Does fitting really require no drilling?",
        a: "Correct. The frame clips onto the window's existing beading, so there is no drilling into your frames — and the blinds can be removed later without a trace.",
      },
      {
        q: "Will Perfect Fit work on my windows?",
        a: "They are designed for uPVC windows and doors with suitable beading, which covers most modern homes. We check compatibility as part of your free measuring visit.",
      },
      {
        q: "Are they child-safe?",
        a: "Yes. There are no loose operating cords or chains — the blind is raised or tilted by the frame itself, making it one of the safest options available.",
      },
    ],
    image: IMG.perfectfit,
    related: ["skylight-blinds", "venetian-blinds", "vertical-blinds"],
  },
  {
    slug: "motorised-blinds",
    name: "Motorised Blinds",
    short:
      "Quiet rechargeable motors with remote, app or smart-home control — luxury that is genuinely useful.",
    heroTagline: "Your blinds, at the touch of a button",
    intro: [
      "Motorised blinds turn an everyday job into a small pleasure. Open the bedroom blinds from bed, shade the afternoon sun across the whole lounge at once, or schedule everything to move while you are away.",
      "Modern battery motors are quiet, discreet and wire-free — no electrician needed in most cases. Control them by handset, app or compatible smart-home assistant, and enjoy the bonus of a completely cord-free, child-safe window.",
    ],
    benefits: [
      "Remote, app or smart-home voice control",
      "Wire-free rechargeable battery motors",
      "Cord-free and child-safe by design",
      "Perfect for hard-to-reach and grouped windows",
    ],
    rooms: ["Bedrooms", "Living rooms", "Lantern roofs", "Hard-to-reach windows"],
    options: [
      "Handsets, wall switches and app control",
      "Timers and sunrise/sunset scheduling",
      "Smart-home integration on selected systems",
      "Solar charging options for sunny windows",
    ],
    light:
      "Programme blinds to lower with the afternoon sun or rise with your alarm — light control that happens without you thinking about it.",
    faqs: [
      {
        q: "Do motorised blinds need wiring in?",
        a: "Usually not. Rechargeable battery motors run for months between charges and simply plug in overnight, so there is no chasing cables into walls.",
      },
      {
        q: "Can I control them when I'm not at home?",
        a: "With app-controlled systems, yes — you can operate your blinds from anywhere, and set schedules so the house looks lived in while you are away.",
      },
      {
        q: "Which blinds can be motorised?",
        a: "Most roller, day & night and roman blinds can be motorised. Bring it up at your design visit and we will confirm the best system for your windows.",
      },
    ],
    image: IMG.motorised,
    video: "https://videos.pexels.com/video-files/6092472/6092472-hd_1920_1080_24fps.mp4",
    videoPoster: "https://images.pexels.com/videos/6092472/pexels-photo-6092472.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
    related: ["roller-blinds", "day-night-blinds", "blackout-blinds"],
  },
  {
    slug: "skylight-blinds",
    name: "Skylight Blinds",
    short:
      "Made-to-measure blinds for roof windows — control heat and light exactly where standard blinds cannot go.",
    heroTagline: "Comfort and shade for roof windows",
    intro: [
      "Roof windows are wonderful for light but can overheat a loft bedroom in summer and flood it with dawn sun. A purpose-made skylight blind runs in side channels, holding the fabric taut at any angle.",
      "We measure your roof windows precisely — every blind is made for the specific window size — and fit them securely so they operate smoothly for years.",
    ],
    benefits: [
      "Made to fit all major roof window sizes",
      "Blackout fabrics for loft bedrooms",
      "Helps manage summer heat and winter chill",
      "Side channels keep fabric taut on the slope",
    ],
    rooms: ["Loft conversions", "Attic bedrooms", "Stairwells", "Extensions"],
    options: [
      "Blackout and dimout fabrics",
      "Manual, telescopic pole or motorised operation",
      "Heat-reflective coatings on selected fabrics",
      "Colour options to blend with your décor",
    ],
    light:
      "Blackout skylight fabrics make a genuine difference in loft bedrooms, blocking early morning sun at the window it comes through.",
    faqs: [
      {
        q: "Can you fit blinds to any roof window?",
        a: "We make blinds to fit all major roof window sizes and styles. During your visit we note the exact window code so the blind is made precisely for it.",
      },
      {
        q: "My skylight is high up — how do I operate the blind?",
        a: "Telescopic poles work well for reachable windows; for anything higher we recommend a motorised blind operated by remote or app.",
      },
      {
        q: "Will a skylight blind help with heat?",
        a: "Yes. Keeping direct sun off the glass noticeably reduces heat build-up in summer, and the fabric adds a layer of insulation on cold nights.",
      },
    ],
    image: IMG.skylight,
    related: ["blackout-blinds", "motorised-blinds", "perfect-fit-blinds"],
  },
  {
    slug: "blackout-blinds",
    name: "Blackout & Thermal Blinds",
    short:
      "Proper darkness for bedrooms and nurseries, plus thermal fabrics that help keep rooms comfortable.",
    heroTagline: "Better sleep, cosier rooms",
    intro: [
      "Whether it is a nursery, a shift worker's bedroom or a street-lit box room, blackout blinds make rooms properly dark — the difference in sleep quality can be remarkable.",
      "Thermal fabrics work the other way too, adding insulation at the window to take the edge off winter draughts and summer heat. Many of our fabrics do both jobs in one blind.",
    ],
    benefits: [
      "Genuine blackout fabrics for real darkness",
      "Thermal linings help rooms stay comfortable",
      "Ideal for nurseries, bedrooms and media rooms",
      "Available as roller, roman or Perfect Fit blinds",
    ],
    rooms: ["Bedrooms", "Nurseries", "Media rooms", "Loft rooms"],
    options: [
      "Blackout roller, roman and pleated fabrics",
      "Thermal and energy-saving linings",
      "Side channels for near-total darkness",
      "Child-safe and motorised options",
    ],
    light:
      "For the darkest result we recommend blackout fabric with Perfect Fit frames or side channels, which close the light gaps at the edges of the blind.",
    faqs: [
      {
        q: "Will a blackout blind make my room completely dark?",
        a: "The fabric itself blocks light entirely. A standard roller leaves a fine halo at the edges; if you need near-total darkness we fit blackout blinds with frames or channels that close those gaps.",
      },
      {
        q: "Are blackout blinds good for children's rooms?",
        a: "They are one of our most requested products for nurseries — especially for summer bedtimes and early dawns. Cord-free and Perfect Fit options keep things child-safe.",
      },
      {
        q: "Do thermal blinds really save energy?",
        a: "A thermal blind adds an insulating layer at the window, which reduces heat loss on cold nights. It is a simple, cost-effective comfort upgrade rather than a substitute for glazing.",
      },
    ],
    image: IMG.blackout,
    related: ["roman-blinds", "skylight-blinds", "perfect-fit-blinds"],
  },
];

export const collections = [
  ...products.map((p) => ({
    slug: p.slug,
    name: p.name,
    short: p.short,
    image: p.image,
    href: `/blinds/${p.slug}`,
  })),
  {
    slug: "shutters",
    name: "Shutters",
    short:
      "Timeless plantation shutters, measured and fitted precisely for privacy, light control and lasting style.",
    image: IMG.shutters,
    href: "/shutters",
  },
];
